/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { ActivityType, ExperienceLevel, AverageYearlyTransactionsType, AverageYearlyVolumeType } from '../types/utils';

export class Activity {
	levelWithAdvice: ExperienceLevel = ExperienceLevel.NONE

	levelWithAssetManagement: ExperienceLevel = ExperienceLevel.NONE

	levelWithoutAdvice: ExperienceLevel = ExperienceLevel.NONE

	transactionsPerYear: AverageYearlyTransactionsType = AverageYearlyTransactionsType.NONE

	type: ActivityType = ActivityType.WP_SERVICE

	volumePerYear: AverageYearlyVolumeType = AverageYearlyVolumeType.LOW
}